var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-blue-50"},[_c('Nav',{staticClass:"relative"}),_c('Helpdesk',{staticClass:"bg-fixed bg-no-repeat bg-cover"}),_c('Footer',{staticClass:"bg-hero-blue px-5"}),_c('Copyright')],1)}
var staticRenderFns = []

export { render, staticRenderFns }